/**
 * Zod schema for `app/config/permissions.json`.
 * Permissive schema that accepts any structure to avoid breaking on unexpected keys.
 */
import { z } from 'zod'

// Accept any object structure for maximum flexibility
export const permissionsSchema = z.record(z.any())

export type ActionPolicy = any
export type EntityPermissions = any
export type PermissionsConfig = Record<string, any>
